import type { SharedBundle } from '../ru/shared';

export const sharedEn: SharedBundle = {
  theme: {
    light: 'Light',
    dark: 'Dark',
    system: 'System',
    switchAria: 'Switch theme',
  },
  sidebar: {
    brand: 'upme admin',
    groups: {
      overview: 'Overview',
      content: 'Content',
      import: 'Import',
      community: 'Community',
      crm: 'CRM',
      monetization: 'Monetization',
      system: 'System',
    },
    nav: {
      home: 'Home',
      events: 'Events',
      eventCategories: 'Event categories',
      places: 'Places',
      placeCategories: 'Place categories',
      services: 'Services',
      serviceCategories: 'Service categories',
      news: 'News',
      sourceChannels: 'Sources',
      extractorConfig: 'Event parser',
      organizerBlocks: 'Blocked organizers',
      importQueue: 'Import queue',
      users: 'Users',
      crmBoard: 'Board',
      crmConversations: 'Conversations',
      crmTelegram: 'Telegram',
      crmInstagram: 'Instagram',
      meetingTemplates: 'Quick start',
      photoModeration: 'Photo moderation',
      promotionTasks: 'Promotion',
      coinTransactions: 'Energy',
      paymentProviders: 'Payments',
      cities: 'Cities',
      morningDigest: 'Morning digest',
    },
    account: 'Account',
    logout: 'Log out',
  },
  support: {
    contactAdmin: 'Please contact the administrator.\nPlease send a screenshot of the error.',
    writeUs: 'Contact us',
  },
};
